<template>
  <div class="mt-8 w-full h-full bg-white">
    <Images />
  </div>
</template>

<script>
import Images from '../components/ImagesUpload/Images.vue';

export default {
  name: 'ImagesUpload',
  components: {
    Images,
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    await this.$store.dispatch('SettingsModule/Config/fetchMerchantProfile');
  },
};
</script>

<style scoped>

</style>
